import { AbstractControl, ValidationErrors } from '@angular/forms';

export function requiredFalse(control: AbstractControl): ValidationErrors | null {
  if (control.value?.toString() !== 'false') {
    return { requiredFalse: true };
  }

  return null;
}
